import { render } from "./LocalDialog.vue?vue&type=template&id=4c0e4c90"
import script from "./LocalDialog.vue?vue&type=script&lang=js"
export * from "./LocalDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__